<template>
    <purchase-sector title="결제수단">
        <v-sheet color="grey lighten-3" class="pa-6">
            <v-row class="ma-n2">
                <template v-for="item in items">
                    <v-col class="pa-2" cols="12" :key="item.value">
                        <purchase-method-item :value="method" v-bind="{ item }" @input="emit" />
                    </v-col>
                </template>
            </v-row>
        </v-sheet>
        <purchase-method-noti ref="purchase-method-noti" />
    </purchase-sector>
</template>

<script>
import { NSHOP_ORDER_PAYMENT_METHODS } from "@/store/nshop";

import PurchaseMethodItem from "./purchase-method-item.vue";
import PurchaseMethodNoti from "./purchase-method-noti.vue";
import PurchaseSector from "./purchase-sector.vue";

/** @typedef {import('@/store/nshop').NshopOrder_Payment_Method} NshopOrder_Payment_Method */

const items = Object.values(NSHOP_ORDER_PAYMENT_METHODS);

export default {
    components: {
        PurchaseMethodItem,
        PurchaseMethodNoti,
        PurchaseSector,
    },
    props: {
        /** @type {import('vue').PropType<NshopOrder_Payment_Method>} */
        value: { type: String, default: "vaccount" },
    },
    data: () => ({
        /** @type {NshopOrder_Payment_Method} */
        method: "vaccount",
        items,
    }),
    methods: {
        sync() {
            this.method = this.value;
        },
        emit(value) {
            if (!items.find((item) => item.value == value).uses) {
                this.$refs["purchase-method-noti"].open();
                return;
            }
            this.method = value;
            this.$emit("input", this.method);
        },
    },
    mounted() {
        this.sync();
    },
};
</script>

<style></style>
